import Actions from '../actions/actions';
import signalSourceConfigurationsCRUDActions from '../actions/SignalSourceConfigurationsCRUDActions';
import {
  SignalSourceConfigurationModel,
  SourceConfiguration,
} from '../model/SignalModel';
import { setBusy, setUnBusy } from './common/commonReducers';

type ActionType = {
  type: string;
  entities: SourceConfiguration[];
  entity: SourceConfiguration;
};

const initialState: SignalSourceConfigurationModel = {
  busy: false,
  sourceConfigurations: [],
};

export const signalSourceConfigurations = (
  state = initialState,
  action: ActionType,
) => {
  switch (action.type) {
    case signalSourceConfigurationsCRUDActions.busyAction:
      return setBusy(state);

    case signalSourceConfigurationsCRUDActions.retrievedAllAction: {
      return {
        ...state,
        sourceConfigurations: action.entities,
        busy: false,
      };
    }
    case signalSourceConfigurationsCRUDActions.retrievedAction: {
      const sourceConfiguration = action.entity;

      const { sourceConfigurations } = state;
      const index = sourceConfigurations.findIndex(
        p => p.id === sourceConfiguration.id,
      );
      const newSourceConfiguration = Object.assign(
        [],
        sourceConfigurations.slice(),
        {
          [index === -1 ? sourceConfigurations.length : index]:
            sourceConfiguration,
        },
      );
      return {
        ...state,
        sourceConfigurations: newSourceConfiguration,
        busy: false,
      };
    }
    case signalSourceConfigurationsCRUDActions.unbusyAction:
      return setUnBusy(state);
    case Actions.UNBUSY:
      return setUnBusy(state);
    default:
      return state;
  }
};
